import React from 'react';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router';
import queryString from 'query-string';

import { PlusOutlined } from '@ant-design/icons';

import { Button } from 'antd';

const Add: React.FC<RouteComponentProps> = ({ history, match }) => {
  return (
    <>
      <Button
        onClick={(): void =>
          history.push({
            pathname: match.url,
            search: queryString.stringify({ a: true })
          })
        }
        type="primary"
        icon={<PlusOutlined />}
      >
        Add
      </Button>
    </>
  );
};

export default withRouter(Add);
